import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const DOCUMENT_CENTER = {
    GET_LIST: createActionTypes("GET_LISTA_DOCUMENT_CENTER"),

    GET_DOCUMENT_CENTER_PRODUCTS: createActionTypes("GET_DOCUMENT_CENTER_PRODUCTS"),

    GET_DOWNLOAD_DOCUMENT_CENTER: createActionTypes("GET_DOWNLOAD_DOCUMENT_CENTER"),

    LOAD_EMPTY: "LOAD_EMPTY_DOCUMENT_CENTER",
    CLEAN_MESSAGE: "CLEAN_MESSAGE_DOCUMENT_CENTER",
    CHANGE_PAGE_SIZE_DOCUMENT_CENTER: "CHANGE_PAGE_SIZE_DOCUMENT_CENTER"
}